import { useState, useEffect } from 'react';
import { FaGithub, FaLinkedin, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const [currentText, setCurrentText] = useState('');
  const fullText = "Full-Stack Software Engineer";
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    if (textIndex < fullText.length) {
      const timeout = setTimeout(() => {
        setCurrentText(fullText.slice(0, textIndex + 1));
        setTextIndex(textIndex + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [textIndex, fullText]);


  return (
    <section className="hero">
      <div className="hero-background">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-left">
            <div className="hero-text">
              <span className="hero-badge">
                <span className="pulse"></span>
                Available for new opportunities
              </span>
              <h1 className="hero-name">
                <span className="gradient-text">SKAND SISODIA</span>
              </h1>
              <h2 className="hero-title">
                I'm a <span className="typing-text">{currentText}</span>
                <span className="cursor">|</span>
              </h2>
              <p className="hero-description">
                I build web and mobile apps, mostly on the backend and the parts of the frontend that
                depend on it. Spent the last few years on healthcare software and cloud tooling, and I
                care about shipping things that are fast, clear, and actually useful.
              </p>
              
              <div className="hero-stats">
                <div className="stat">
                  <span className="stat-number">3.5+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
                <div className="stat">
                  <span className="stat-number">5+</span>
                  <span className="stat-label">Products Shipped</span>
                </div>
                <div className="stat">
                  <span className="stat-number">Web + Mobile</span>
                  <span className="stat-label">Platforms</span>
                </div>
              </div>

              <div className="hero-buttons">
                <a href="#contact" className="btn btn-primary">
                  Get In Touch
                </a>
                <a href="#projects" className="btn btn-secondary">
                  View Projects
                </a>
              </div>
            </div>
          </div>
          
          <div className="hero-right">
            <div className="profile-container">
              <div className="profile-image">
                <img 
                  src="/images/profile.jpeg" 
                  alt="SKAND SISODIA" 
                />
                <div className="profile-overlay"></div>
                <div className="profile-glow"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="hero-contact">
          <div className="contact-item">
            <FaEnvelope className="icon" />
            <span>sisodiaskand@gmail.com</span>
          </div>
          <div className="contact-item">
            <FaMapMarkerAlt className="icon" />
            <span>Ghaziabad, Uttar Pradesh, India</span>
          </div>
          <div className="contact-item">
            <FaLinkedin className="icon" />
            <a href="https://www.linkedin.com/in/skand-sisodia-37691719b" target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
          </div>
          <div className="contact-item">
            <FaGithub className="icon" />
            <a href="https://github.com/skandsisodia87" target="_blank" rel="noopener noreferrer">
              GitHub
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
